import React from 'react';
import '../styles/Navbar.css';

export default function Navbar() {
  return (
    <nav className="navbar">
      <div className="nav-container">
        <a href="/" className="nav-logo">Joseph Chiarito</a>
        <ul className="nav-menu">
          <li><a href="/" className="nav-link">Home</a></li>
          <li><a href="#projects" className="nav-link">Projects</a></li>
          <li><a href="#experience" className="nav-link">Experience</a></li>
          <li><a href="#skills" className="nav-link">Skills</a></li>
        </ul>
      </div>
    </nav>
  );
}
